import { Close } from "@mui/icons-material";
import { Alert, IconButton, Modal, Stack, Typography } from "@mui/material";
import { useCallback } from "react";
import LoadingButton from "src/components/Buttons/LoadingButton";
import { useSelection } from "src/context/ItemsSelectionProvider/useSelection";
import { desktopSx } from "src/utils/styles/modalStyles";

interface Props {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  loading: boolean;
}

const RemoveItemModal = ({ onClose, open, onDelete, loading }: Props) => {
  const { selected, setSelected } = useSelection();

  const handleRemove = useCallback(() => {
    onDelete();
    setSelected([]);
    onClose();
  }, [onClose, onDelete, setSelected]);

  return (
    <Modal open={open} onClose={onClose}>
      <Stack sx={desktopSx} gap={3}>
        <Stack
          direction={"row"}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h5" component="h5" fontWeight={700}>
            Remove items
          </Typography>

          <IconButton onClick={onClose} sx={{ p: 0 }}>
            <Close fontSize="medium" />
          </IconButton>
        </Stack>
        <Alert severity="warning">
          <Typography
            color="warning"
            sx={{ textDecoration: "underline" }}
            variant="h6"
          >
            Items selected
          </Typography>
          <Typography fontWeight={600} variant="h6">
            {selected.join(", ")}
          </Typography>
        </Alert>
        <Stack gap={1}>
          <Alert severity="error">
            Are you sure you want to remove items above?
          </Alert>
          <LoadingButton loading={loading} onClick={handleRemove} color="error">
            Remove items
          </LoadingButton>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default RemoveItemModal;
